define([
	"csi/_base/underscore",
	"./crews"
], function(_,crews) {

	// view resource access for roles
	//	"Type":{
	//		"View Id":{
	//			"Resource Id":{	 		// "" to specify view access
	//				_d:<access>,			// the default access level if the user doesn't play any roles specified below
	//				"Role1":<access>,
	//				"Role2":<access>,
	//				...
	//		  }
	//		}
	//	},
	//
	//	where <access> is a number representing an access level (see RESOURCE_... constants above):
	//		0 - no access
	//		1 - read-only access
	//		2 - full access
	var	_viewRoles = {};

	return {
		// Use to remove all access to view/resource when calling addViewRoles
		NONE: {$: 0},

		// Access levels for views and view resources
		RESOURCE_NO_ACCESS: 0,
		RESOURCE_READ_ONLY_ACCESS: 1,
		RESOURCE_FULL_ACCESS: 2,
		RESOURCE_FREE_ACCESS: 3,

		// The key for the default access
		DEFAULT_RESOURCE_ACCESS_KEY: "$",

		addViewRoles: function(/*Object*/sourceObj, /*Boolean?*/bForceRoles) {
			// summary: merge additional view-role mappings
			_.each(sourceObj,function(sourceTypeObj,sourceTypeId){
				var targetTypeObj = (_viewRoles[sourceTypeId] = _viewRoles[sourceTypeId] || {});

				_.each(sourceTypeObj,function(sourceViewObj,sourceViewId){
					var targetViewObj = (targetTypeObj[sourceViewId] = targetTypeObj[sourceViewId] || {});

					_.each(sourceViewObj,function(sourceResourceObj,sourceResourceId){
						if (bForceRoles)
							targetViewObj[sourceResourceId] = sourceResourceObj;
						else {
							var targetResourceObj = (targetViewObj[sourceResourceId] = targetViewObj[sourceResourceId] || {});

							_.each(sourceResourceObj,function(sourceAccessLevel,sourceRoleId){
								targetResourceObj[sourceRoleId] = Math.max(targetResourceObj[sourceRoleId]||0, sourceAccessLevel);
							});
						}
					});
				});
			});
		},

		getViewRoles: function() {
			return _viewRoles;
		},

		setViewRoles: function(/*Object*/obj) {
			// summary: replace view roles as a whole. Used in Site_Merged file.
			_viewRoles = obj;
		},

		getViewAccess: function(/*String*/type, /*String*/idView, /*Node*/node) {
			// summary: determine if role has access to the given view
			return this.getViewResourceAccess(type, idView, null, node);
		},

		getViewResourceAccess: function(/*String*/type, /*String*/idView, /*String?*/resourceID, /*Node*/node) {
			// summary: determine if the role has an access to the given view resource;
			var	o = type ? _viewRoles[type] : null;
			var	v = (o && idView) ? o[idView] : null;
			if (v) {
				if (resourceID) {
					v = v[resourceID];
				} else {
					// if there is an empty string mapping, then use that to represent view
					var objToLookup = v[""];
					if (objToLookup != null) {
						v = objToLookup;
					}
				}
			}

			var	n = _.size(v);
			if (!n) {
				// if no access control configured for resource, then return free access - different from full access in that
				// it indicates that there are no roles configured for the action vs. a user have all the roles needed for access
				return this.RESOURCE_FREE_ACCESS;
			} else if (crews.isAdmin()) {
				// if admin user, then return full access
				return this.RESOURCE_FULL_ACCESS;
			}

			// before looking up roles for node, check to see if any roles are there to check against
			var	userDefaultAccess = v[this.DEFAULT_RESOURCE_ACCESS_KEY];
			if ((n == 1) && (userDefaultAccess != null)) {
				return userDefaultAccess;
			}

			// get roles for node
			var	roles = crews.getRolesOfNode(node);
			var	userAccessLevel = this.RESOURCE_NO_ACCESS;
			var userPlaysSomeSpecifiedRole = false;

			for(var i=0; i<roles.length && userAccessLevel < this.RESOURCE_FULL_ACCESS; i++) {
				var roleAccessLevel = v[roles[i]];
				if (roleAccessLevel != null) {
					userPlaysSomeSpecifiedRole = true;
					userAccessLevel = Math.max(userAccessLevel,roleAccessLevel);
				}
			}

			// if the user doesn't play the role specified on the resource, get the default access level
			if (!userPlaysSomeSpecifiedRole) {
				userAccessLevel = userDefaultAccess;
			}

			// if the access level is not specified for the resource, make it fully accessible
			if (userAccessLevel == null) {
				userAccessLevel = this.RESOURCE_FULL_ACCESS;
			}

			return userAccessLevel;
		},

		hideResource: function(/*String*/type, /*String*/idView, /*String?*/idAction) {
			// summary: hide view or action for all roles
			var	t = _viewRoles[type] = _viewRoles[type] || {};
			var	v = t[idView] = t[idView] || {};
			v[idAction] = this.NONE;
		},

		isResourceHidden: function(/*String*/type, /*String*/idView, /*String?*/idAction) {
			// summary: return true if given resource was hidden
			if (crews.isAdmin()) {
				return false;
			}

			var t = _viewRoles[type];
			var v = t && t[idView];
			var r = v && v[idAction || ""];
			return r && (r.$ === 0) && (_.size(r) === 1);
		},

		convertRolesArrayIntoHash: function(/*String[]*/roles, /*int*/accessLevel) {
			var hash = {};
			for(var i=0; i<roles.length; i++) {
				hash[roles[i]] = accessLevel;
			}
			return hash;
		}
	};
});